import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/legacy/Cookies.tsx");
